import { Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Agenda from './Agenda';

export const AgendaRoutes = (
  <Route
    path="agenda"
    element={(
      <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep']}>
        <Agenda />
      </PrivateRoute>
    )}
  />
);
